import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { triggerBase64Download } from 'common-base64-downloader-react';
import {
  Container,
  Card,
  Form,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Col,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faScissors,
  faGenderless,
  faGraduationCap,
  faUnderline,
  faChild,
  faBed,
  faAmbulance,
  faMoneyBill,
  faSearch,
  faBabyCarriage,
} from "@fortawesome/free-solid-svg-icons";
import { 
  updateSearch,
  searchLeaveSummary,
  getLeaveSummaryPageCount,
  printExcel
} from '../../3.Store/LeaveSummarySlice';
import { ThreeDots } from 'react-loader-spinner';
import Pagination from "../../2.Commons/Pagination";

const LeaveSummaryList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const employee = JSON.parse(localStorage.getItem("current_user"));
  const userId = employee?.id;
  const searchResult = useSelector(state => state.LeaveSummarySlice.summaries);
  const search = useSelector((state) => state.LeaveSummarySlice.search);
  const loading = useSelector((state) => state.LeaveSummarySlice.loading);
  const loading2 = useSelector((state) => state.LeaveSummarySlice.loading2);
  const { searchText, year } = search;

  const roles = JSON.parse(localStorage.getItem("roles"));
  const isHR = roles.includes("HR-L-SUMMARY");

  // Pagination logic
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const totalPages = Math.ceil(searchResult.length / itemsPerPage);
  const currentItems = searchResult.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  useEffect(() => {
    if(!isHR){
      localStorage.clear(); 
      window.location.href = "/Login"; 
    }
    dispatch(getLeaveSummaryPageCount());
    // dispatch(getLeaveSummaryEmployeeYear({ id: userId, year }));
    const entity = { ...search };
    dispatch(searchLeaveSummary(entity));
  }, []);

  const handleSearch = (e) => {
    const entity = {...search, searchText: e.target.value}
    console.log(entity);
    dispatch(updateSearch(entity));
  };

  const handleBtnSearch = () => {
    setCurrentPage(1);
    const entity = { ...search };
    dispatch(searchLeaveSummary(entity));
  };

  const handleYear = (e) => {
    setCurrentPage(1);

    const entity = {...search, year: e.target.value}
      dispatch(updateSearch(entity));
      dispatch(searchLeaveSummary(entity));
  };

  const handleBtnDownload = () => {
    if(isHR) {
      const entity = {...search, searchText: employee.fullname}
      console.log(entity)
    }

    // const report = dispatch(printExcel({searchText, year}));
    const report = dispatch(printExcel(searchResult));
    
    report.then((data) => {
        try {
            // Ensure the payload is a string
            if (typeof data.payload !== 'string') {
                throw new Error('Invalid payload format');
            }
            // Decode the base64-encoded data
            const base64EXCEL = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data.payload}`;
            // Trigger download
            triggerBase64Download(base64EXCEL, "Leave Summary (" + year + ") - " + employee.fullname);
        } catch (error) {
            console.error('Error handling download:', error);
        }
    }).catch((error) => {
        console.error('Error fetching report data:', error);
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBtnSearch();
    }
  };

  const handleBtnBack = () => {
    navigate("/");
  };

  // Function to generate options for the dropdown menu
  const renderYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= currentYear - 5; year--) {
        years.push(
            <option key={year} value={year}>{year}</option>
        );
    }
    return years;
  };

  const handleClickView = (employeeId) => {
    navigate(`/HRLeaveReportForm/${employeeId}?year=${year}`);
  };

  // Filtering the list based on searchText and year whenever they change
  // const filteredResults = searchResult.filter(employee => 
  //   employee.employee.fullname.toLowerCase().includes(searchText.toLowerCase()) &&
  //   (year ? employee.year === year : true)
  // );

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };  

  return (
    <div className="ContainerContent2">
      {(loading || loading2) && (
        <ThreeDots
          visible={(loading || loading2)}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">Leave Summary</h1>

        {isHR && (
        <InputGroup className="mb-3">
          <Form.Control 
            placeholder="Search" 
            value={searchText} 
            onChange={handleSearch} 
            onKeyPress={handleKeyPress}
          />

          <Button className="SearchIconBtn" onClick={handleBtnSearch}>
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </InputGroup>
        )}
        
        <Col md={1} sm={1} style={{ marginLeft: "auto" }}>
          {/* Dropdown menu for selecting the year */}
          <Form.Select value={year} onChange={handleYear}>
              {renderYearOptions()}
          </Form.Select>
        </Col>

        <div><br/></div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div style={{ overflowX: 'auto' }}>
          <Table className="my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "150px" }}>Employee</th>
                <th style={{ width: "40px" }}>OB</th>
                <th style={{ width: "40px" }}>LA</th>
                <th style={{ width: "40px" }}>1</th>
                <th style={{ width: "40px" }}>2</th>
                <th style={{ width: "40px" }}>3</th>
                <th style={{ width: "40px" }}>4</th>
                <th style={{ width: "40px" }}>5</th>
                <th style={{ width: "40px" }}>6</th>
                <th style={{ width: "40px" }}>7</th>
                <th style={{ width: "40px" }}>8</th>
                <th style={{ width: "40px" }}>9</th>
                <th style={{ width: "40px" }}>10</th>
                <th style={{ width: "40px" }}>11</th>
                <th style={{ width: "40px" }}>12</th>
                <th style={{ width: "40px" }}>TTL</th>
                <th style={{ width: "40px" }}>CF</th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faScissors} title="Prorated" />
                </th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faGenderless} title="Other Leave" />
                </th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faGraduationCap} title="Special Leave" />
                </th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faUnderline} title="Unpaid Leave" />
                </th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faChild} title="Maternity Leave" />
                </th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faBabyCarriage} title="Paternity Leave" />
                </th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faBed} title="Sick Leave" />
                </th>
                <th style={{ width: "40px" }}>
                  <FontAwesomeIcon icon={faAmbulance} title="Hospitalization" />
                </th>
                <th style={{ width: "60px" }}>
                  <FontAwesomeIcon icon={faMoneyBill} title="Medical Taken" />
                </th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map(employee => (
                    <tr key={employee.employee.id} onClick={() => handleClickView(employee.employee.id)} style={{ cursor: "pointer" }}>
                      {/* <td>{employee.employee.fullname}</td> */}
                      <td>
                        {employee.employee.fullname
                          .toLowerCase()
                          .split(' ')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')}
                      </td>
                      <td>{employee.ob}</td>
                      <td>{employee.entitled}</td>
                      <td>{employee.jan}</td>
                      <td>{employee.feb}</td>
                      <td>{employee.mar}</td>
                      <td>{employee.apr}</td>
                      <td>{employee.may}</td>
                      <td>{employee.jun}</td>
                      <td>{employee.jul}</td>
                      <td>{employee.aug}</td>
                      <td>{employee.sep}</td>
                      <td>{employee.oct}</td>
                      <td>{employee.nov}</td>
                      <td>{employee.dec}</td>
                      <td>{employee.utilized}</td>
                      <td>{employee.cf}</td>
                      <td>{employee.prorated}</td>
                      <td>{employee.other}</td>
                      <td>{employee.special}</td>
                      <td>{employee.unpaid}</td>
                      <td>{employee.maternity}</td>
                      <td>{employee.paternity}</td>
                      <td>{employee.sick}</td>
                      <td>{employee.hospitalization}</td>
                      <td>{employee.medicalbenefit}</td>
                    </tr>
                  ))
                  ) : (
                  <tr>
                    <td colSpan="26">No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnDownload}>
              Download
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default LeaveSummaryList;